import createCache from 'services/createCache';

export default createCache({
	freerideMap: {
		map: null,
		buildingsLayer: null,
		buildingsMarkersLayer: null,
		mapLayer: null,
		markerLayer: null,
		groundwaterAreasLayer: null,
		propertyLinesLayer: null,
	},
});
